<template>
  <div style="margin: 50px auto 50px; margin-top: 50px;margin-bottom:60px; max-width: 80%; text-align: left;">

    <el-form :model="ruleForm" :label-position="labelPosition" label-width="150px">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" size="medium" @click="dialogChange_info()" plain>
            {{ $t("userHome.change_info") }}
          </el-button>
          <el-button type="warning" size="medium" @click="dialogPassword = true" plain>
            {{ $t("userHome.change_password") }}
          </el-button>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col class="grid-content info-bg" :span="14">
          <div style="text-align: left; ">

            <el-form-item class="label-style1" :label="$t('userHome.username')">
              {{tableForm.username}}
            </el-form-item>

            <el-form-item class="label-style1" :label="$t('userHome.nickname')">
              {{tableForm.nickname}}
            </el-form-item>

            <el-form-item class="label-style1" label="言語">
              {{tableForm.locale}}
            </el-form-item>

            <el-form-item class="label-style1" label="パスワード">
              {{tableForm.password}}
            </el-form-item>

            <el-form-item class="label-style1" label="会員プラン">
              {{tableForm.plan}}&nbsp;
              <el-button class="el-icon-edit-outline" type="text" @click="changePlan()">編集
              </el-button>
            </el-form-item>

            <el-form-item class="label-style1" :label="$t('userHome.email')">
              {{tableForm.email}}
              <el-button class="el-icon-edit-outline" type="text" @click="dialogEmail = true">編集
              </el-button>
            </el-form-item>

            <el-form-item class="label-style2" :label="$t('userHome.phone')">
              {{tableForm.phone}}
              <el-button class="el-icon-edit-outline" type="text" @click="dialogPhone = true">編集
              </el-button>
              <el-button class="el-icon-delete" type="text" @click="handleDelete()">削除
              </el-button>
            </el-form-item>
            <p class="p-style">＊SMS認証を行うため、携帯電話番号を登録してください。</p>
          </div>
        </el-col>

        <el-col :span="10" justify="right">
          <div style="margin: 10px auto 10px; max-width: 80%; margin-left: 150px; text-align: center;">
            <el-upload class="avatar-uploader demo-basic--circle" action="/senseSys/uploadImg" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="tableForm.userface" :src="tableForm.userface" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div slot="tip" class="el-upload__tip">{{ $t("userHome.size_limit") }}
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <!--change info-->
    <el-dialog :title="$t('userHome.change_info')" :append-to-body="true" :visible.sync="dialogInfo" width="50%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="160px" class="demo-ruleForm" size="medium">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>

          <el-form-item class="label-style1" :label="$t('userHome.username')" prop="username">
            <el-input class="input-style1" prefix-icon="el-icon-edit" size="mini" v-model="ruleForm.username" :placeholder="$t('userHome.username')" clearable>
            </el-input>
          </el-form-item>

          <el-form-item class="label-style1" :label="$t('userHome.nickname')" prop="nickname">
            <el-input class="input-style1" prefix-icon="el-icon-edit" size="mini" v-model="ruleForm.nickname" :placeholder="$t('userHome.nickname')" clearable>
            </el-input>
          </el-form-item>

          <el-form-item class="label-style1" :label="$t('userHome.locale')" prop="locale">
            <el-select class="input-style1" size="mini" v-model="ruleForm.locale" :placeholder="$t('userHome.locale')" clearable>
              <el-option v-for="item in infoChanges" :key="item.infoId" :label="item.label" :value="item.infoId" :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>

        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeInfo('ruleForm')" style="width: 120px" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button @click="dialogInfo = false" style="width: 120px" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <!--change password-->
    <el-dialog :title="$t('userHome.change_password')" :append-to-body="true" :visible.sync="dialogPassword" width="50%" :before-close="handleClose">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="190px" class="demo-ruleForm" size="mini">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="24">
            <div>
              <el-form-item style="margin-left:39px;margin-bottom:39px" :label="$t('userHome.password')" prop="old_password">
                <el-input type="password" class="input-style1" prefix-icon="el-icon-edit" size="medium" v-model="ruleForm.old_password" :placeholder="$t('userHome.password')" autocomplete="off" show-password clearable>
                </el-input>
              </el-form-item>

              <el-form-item style="margin-left:39px" :label="$t('userHome.new_password')" prop="new_password">
                <el-input type="password" class="input-style1" prefix-icon="el-icon-edit" size="medium" v-model="ruleForm.new_password" :placeholder="$t('userHome.new_password')" autocomplete="off" show-password clearable>
                </el-input>
                <password-strength class="input-style1" v-model="ruleForm.new_password" style="padding-top: 10px;"></password-strength>
              </el-form-item>

              <el-form-item style="margin-left:39px" :label="$t('userHome.comfirm_password')" prop="comfirm_password">
                <el-input type="password" class="input-style1" prefix-icon="el-icon-edit" size="medium" v-model="ruleForm.comfirm_password" :placeholder="$t('userHome.comfirm_password')" autocomplete="off" clearable>
                </el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePassword('ruleForm')" style="width: 120px" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button @click="s1_cancel('ruleForm')" style="width: 120px" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <!--change plan-->
    <el-dialog title="提示" :visible.sync="dialogPlan" width="90%" :before-close="handleClose">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPlan = false">取 消</el-button>
        <el-button type="primary" @click="dialogPlan = false">确 定</el-button>
      </span>
    </el-dialog>

    <!--change email-->
    <el-dialog title="新しいメールアドレスに変更する" :visible.sync="dialogEmail" width="39%" :before-close="handleClose">
      <el-form :model="ruleEmail" status-icon :rules="rules" ref="ruleEmail" label-width="0px" class="demo-ruleEmail">
        <el-form-item prop="email">
          <el-input placeholder="新しいメールアドレスを入力してください" v-model="ruleEmail.email" style="width: 360px;margin-left:23px" clearable>
          </el-input>
          <el-button icon="el-icon-message" @click="sendEmailValidationCode()" style="width: 140px" type="success" :disabled="(disabled = !show)">
            <span v-show="show">送信する</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </el-button>
        </el-form-item>
        <el-form-item prop="verificationCode">
          <el-input v-model="ruleEmail.validationCode" placeholder="確認コードを入力してください" style="width: 360px;margin-left:23px" clearable></el-input>
          <el-button icon="el-icon-circle-check" style="width: 140px" type="primary" @click="submitEmailValidation()">送信する</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="s1_cancel('ruleEmail')">閉じる</el-button>
      </span>
    </el-dialog>

    <!--change phone-->
    <el-dialog title="新しい電話番号に設定する" :visible.sync="dialogPhone" width="39%" :before-close="handleClose">
      <el-form :model="rulePhone" status-icon :rules="rules" ref="rulePhone" label-width="0px" class="demo-rulePhone">
        　<span></span>
        　<el-form-item prop="phone">
          <el-input placeholder="新しい電話番号を入力してください" v-model="rulePhone.phoneNumber" style="width: 360px;margin-left:23px" clearable>
            <!-- <el-select v-model="rulePhone.num" slot="prepend" placeholder="選んでください" style="width: 100px">
              <el-option v-for="item in numList" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select> -->
          </el-input>
          <el-button icon="el-icon-mobile-phone" @click="sendValidationCode()" style="width: 140px" type="success" :disabled="(disabled = !show)">
            <span v-show="show">送信する</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </el-button>
        </el-form-item>
        <el-form-item prop="verificationCode">
          <el-input v-model="rulePhone.validationCode" placeholder="確認コードを入力してください" style="width: 360px;margin-left:23px" clearable></el-input>
          <el-button icon="el-icon-circle-check" style="width: 140px" type="primary" @click="submitValidation()">送信する</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="s1_cancel('rulePhone')">閉じる</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRequest } from "../utils/api";
import { putRequest } from "../utils/api";
import { deleteRequest } from "../utils/api";
import PasswordStrength from "@/components/Public/PasswordStrength";

const TIME_COUNT = 30; //更改倒计时时间
export default {
  components: { PasswordStrength },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("userHome.new_password_error")));
      } else {
        if (this.ruleForm.comfirm_password !== '') {
          this.$refs.ruleForm.validateField('comfirm_password');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("userHome.new_password_error")));
      } else if (value !== this.ruleForm.new_password) {
        callback(new Error(this.$t("userHome.comfirm_password_error")));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "left",
      dialogInfo: false,
      dialogPassword: false,
      dialogPlan: false,
      dialogEmail: false,
      dialogPhone: false,
      infoChanges: [{
        infoId: '日本語',
        label: '日本語'
      }, {
        infoId: '英語',
        label: '英語',
        disabled: true
      }],
      show: true, // 初始启用按钮
      count: "", // 初始化次数
      timer: null,
      select: "",
      numList: [
        {
          id: 0,
          name: "日本+81",
        },
        {
          id: 1,
          name: "中国+86",
        },
        {
          id: 2,
          name: "缅甸+95",
        },
        {
          id: 3,
          name: "印度+91",
        },
        {
          id: 4,
          name: "韩国+82",
        },
      ],
      tableForm: {
        username: "",
        nickname: "",
        email: "",
        phone: "",
        userface: "",
        regTime: "",
        plan: "",
        locale: "",
        password: "",
      },
      ruleForm: {
        username: "",
        nickname: "",
        email: "",
        phone: "",
        userface: "",
        regTime: "",
        plan: "",
        locale: "",
        password: "",
        old_password: "",
        new_password: "",
        comfirm_password: "",
      },
      rulePhone: {
        phoneNumber: "",
        num: "日本+81",
        validationCode: "",
      },
      ruleEmail: {
        email: "",
        validationCode: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$t("register.usernameRule"),
            trigger: "blur",
          },
          {
            pattern: /^[A-Za-z0-9_]+$/,
            message: this.$t("register.usernamePattern"),
          },
        ],
        email: [{
          required: true,
          message: this.$t("userHome.fill"),
          trigger: "blur",
        },],
        phoneNumber: [{
          required: true,
          message: this.$t("userHome.fill"),
          trigger: "blur",
        },],
        old_password: [{
          required: true,
          message: this.$t("userHome.fill_old_pw"),
          trigger: "blur",
        },
        ],
        new_password: [{
          required: true,
          message: this.$t("userHome.fill_new_pw"),
          trigger: "blur",
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
          message: this.$t("register.passwordPattern"),
        },],
        comfirm_password: [{
          required: true,
          message: this.$t("register.password2"),
          trigger: "blur",
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
          message: this.$t("register.passwordPattern"),
        },]
      },
    };

  },
  methods: {
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          this.deletePhone();
        })
        .catch(() => {
        });
    },
    deletePhone() {
      let postData = this.qs.stringify({
        phoneNumber: "",
      });
      this.axios({
        method: "post",
        url: "/updatePhone",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.delete_completed"),
          });
        })
        .catch((error) => {

        });
    },
    dialogChange_info() {
      this.dialogInfo = true;
      this.ruleForm.username = this.tableForm.username;
      this.ruleForm.nickname = this.tableForm.nickname;
      this.ruleForm.locale = this.tableForm.locale;
    },
    jump(path) {
      this.$router.push(path);
    },
    handleAvatarSuccess(res, file) {
      this.tableForm.userface = URL.createObjectURL(file.raw);
      this.$message({
        type: "success",
        message: this.$t("general.uploadCompleted"),
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$t("userHome.jpg_format"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("userHome.oversize"));
      }
      return isJPG && isLt2M;
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    s1_cancel(ruleForm) {
      this.dialogInfo = false;
      this.dialogPassword = false;
      this.dialogPhone = false;
      this.dialogEmail = false;

      this.ruleEmail = {
        email: "",
        validationCode: "",
      };
      this.rulePhone = {
        phoneNumber: "",
        validationCode: "",
        num: "日本+81",
      }
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogInfo = false;
      this.dialogPassword = false;
    },

    changeInfo(ruleForm) {
      if (this.ruleForm.username === this.tableForm.username) {
        let postData = this.qs.stringify({
          nickname: this.ruleForm.nickname,
          locale: this.ruleForm.locale == "日本語" ? this.ruleForm.locale = "ja" : this.ruleForm.locale == "英語" ? this.ruleForm.locale = "en" : this.ruleForm.locale = "ja",
        });
        this.axios({
          method: "post",
          url: "/updateUserInfoSameName",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.s1_cancel(ruleForm);
            this.$message.success('更新しました。');
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.edit_failed"),
            });
            console.log(error);
          });
        this.ruleForm.locale == "ja" ? this.ruleForm.locale = "日本語" : this.ruleForm.locale = "英語";
      } else {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              username: this.ruleForm.username,
              nickname: this.ruleForm.nickname,
              locale: this.ruleForm.locale == "日本語" ? this.ruleForm.locale = "ja" : this.ruleForm.locale == "英語" ? this.ruleForm.locale = "en" : this.ruleForm.locale = "ja",
            });
            this.axios({
              method: "post",
              url: "/updateUserInfo",
              data: postData,
            })
              .then((response) => {
                if (response.status == 200) {
                  var json = response.data;
                  if (json.status == "success") {
                    this.handleCurrentChange();
                    this.s1_cancel(ruleForm);
                    this.$message.success('更新しました。新しいユーザー名ログインしてください！');
                    window.localStorage.removeItem('LoginUserId');
                    getRequest("/logout");
                    this.$router.replace({
                      path: "/",
                    });
                  } else if (json.status == "usernameError") {
                    this.$message.warning('ユーザ名がすでに登録されています。');
                  }
                }
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
          this.ruleForm.locale == "ja" ? this.ruleForm.locale = "日本語" : this.ruleForm.locale = "英語";

        });
      }
    },
    changePlan() {
      this.$message.success('システムは無料トライアル中です、他の会員プランをお楽しみに！');
    },
    changePassword(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid && this.ruleForm.new_password == this.ruleForm.comfirm_password) {
          let postData = this.qs.stringify({
            old_password: this.ruleForm.old_password,
            password: this.ruleForm.new_password,
          });
          this.axios({
            method: "post",
            url: "/updatePassword",
            data: postData,
          })
            .then((resp) => {
              this.handleCurrentChange();
              if (resp.status == 200) {
                var json = resp.data;
                if (json.status == "success") {
                  this.$message({
                    type: "success",
                    message: 'パスワード更新しました。',
                  });
                  this.s1_cancel(ruleForm);
                  window.localStorage.removeItem('LoginUserId');
                  getRequest("/logout");
                  this.$router.replace({
                    path: "/",
                  });
                } else if (json.status == "old_passwordError") {
                  this.$message({
                    type: "error",
                    message: '以前のパスワード確認失敗しました。',
                  });
                } else {
                  this.$message({
                    type: "warning",
                    message: 'サーバーエラー',
                  });
                  this.s1_cancel(ruleForm);
                }
              }
              console.log(response);
            })

        } else {
          this.$message({
            type: "warning",
            message: 'パスワードが一致しません',
          });
        }
      });
    },
    emptyUserData() {
      this.ruleForm = {
        username: "",
        nickname: "",
        email: "",
        phone: "",
        userface: "",
        regTime: "",
        password: "",
        new_password: "",
        comfirm_password: "",
      }
    },
    handleCurrentChange() {
      console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageUserHome",
        data: postData,
      })
        .then((response) => {
          this.tableForm = response.data;
          this.tableForm.plan == "a" ? this.tableForm.plan = "無料プラン" : this.tableForm.plan == "b" ? this.tableForm.plan = "スタンダードプラン" : this.tableForm.plan = "プロフェッショナルプラン";
          this.tableForm.locale == "ja" ? this.tableForm.locale = "日本語" : this.tableForm.locale = "英語";
          this.tableForm.password = "*********";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changePhone(rulePhone) {
      this.$refs[rulePhone].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            phoneNumber: this.rulePhone.phoneNumber,
          });
          this.axios({
            method: "post",
            url: "/updatePhone",
            data: postData,
          })
            .then((resp) => {
              this.handleCurrentChange();
              if (resp.status == 200) {
                var json = resp.data;
                if (json.status == "success") {
                  this.s1_cancel(rulePhone);
                  this.$message({
                    type: "success",
                    message: this.$t("general.edit_completed"),
                  });
                }
              } else {
                this.$message({
                  type: "warning",
                  message: 'サーバーエラー',
                });
                this.s1_cancel(rulePhone);
              }
              console.log(response);
            })
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });

    },
    submitValidation() {
      let postData = this.qs.stringify({
        validationCode: this.rulePhone.validationCode,
        phoneNumber: this.rulePhone.num.substring(2, 5) + this.rulePhone.phoneNumber,
      });
      this.axios({
        method: "post",
        url: "/checkValidation",
        data: postData,
      })
        .then((resp) => {
          //成功
          if (resp.status == 200) {
            var json = resp.data;
            if (json.status == "success") {

              this.changePhone('rulePhone'),
                this.$message({
                  type: "success",
                  message: "確認しました。",
                });
              console.log(response);
            } else if (json.status == "error") {
              this.$message({
                type: "warning",
                message: "入力した確認コードが正しくありません",
              });
            }
          } else {
            this.$message.error({
              message: "サーバーエラー",
            });
          }

        })
    },
    sendValidationCode() {
      if (!this.timer) {
        this.sendMessage('rulePhone'); //调用AWS API发送手机验证码
        this.count = TIME_COUNT;
        this.show = false; //点击按钮后，变为不可用
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--; //60s倒计时递减
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
          }
        }, 1000);
      }
    },
    sendMessage(rulePhone) {
      this.$refs[rulePhone].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            phoneNumber:
              this.rulePhone.num.substring(2, 5) + this.rulePhone.phoneNumber, //拼接字符串,选择的地区号码和入力的手机号码形成完整的手机号码
          });
          this.axios({
            method: "post",
            url: "/sendMessage",
            data: postData,
          })
            .then((resp) => {
              if (resp.status == 200) {
                var json = resp.data;
                if (json.status == "success") {
                  this.$message({
                    type: "success",
                    message: "送信しました。",
                  });
                }
                if (json.status == "sendPhoneError") {
                  this.$message({
                    type: "error",
                    message: "更新された電話番号が既に存在しています。",
                  });
                }

              }
            })
            .catch((error) => {
              if (error.message == "Request failed with status code 500") {
                this.$message({
                  type: "warning",
                  message: "有効な電話番号を入力して下さい",
                });
              } else {
                this.$message.error({
                  message: "サーバーエラー",
                });
                console.log(error);
              }
            });
        } else {
          this.$message({
            type: "warning",
            message: "電話番号を入力して下さい",
          });
        }
      });
    },
    sendEmailMessage(ruleEmail) {
      this.$refs[ruleEmail].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            email: this.ruleEmail.email,
          });
          this.axios({
            method: "post",
            url: "/sendEmailMessage",
            data: postData,
          })
            .then((resp) => {
              if (resp.status == 200) {
                var ejson = resp.data;
                if (ejson.status == "success") {
                  this.$message({
                    type: "success",
                    message: "送信しました。",
                  });
                }
                if (ejson.status == "emailUpdateError") {
                  this.$message({
                    type: "error",
                    message: "登録されたメールアドレスが既に存在しています。",
                  });
                }
              }
            })
            .catch((error) => {
              this.$message.error({
                message: "サーバーエラー",
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "warning",
            message: "メールアドレスを入力して下さい",
          });
        }
      });
    },
    sendEmailValidationCode() {
      if (!this.timer) {
        this.sendEmailMessage('ruleEmail');
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--; //60s倒计时递减
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
          }
        }, 1000);
      }
    },
    submitEmailValidation() {
      let postData = this.qs.stringify({
        validationCode: this.ruleEmail.validationCode,
        email: this.ruleEmail.email,
      });
      this.axios({
        method: "post",
        url: "/checkEmailValidation",
        data: postData,
      })
        .then((resp) => {
          //成功
          if (resp.status == 200) {
            var json = resp.data;
            if (json.status == "success") {
              this.changeEmail('ruleEmail'),
                this.$message({
                  type: "success",
                  message: "確認しました。",
                });

              console.log(response);
            } else if (json.status == "error") {
              this.$message({
                type: "warning",
                message: "入力した確認コードまたはメールアドレスが正しくありません",
              });
            }
          } else {
            this.$message.error({
              message: "サーバーエラー",
            });
          }
        })
    },
    changeEmail(ruleEmail) {
      this.$refs[ruleEmail].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            email: this.ruleEmail.email,
          });
          this.axios({
            method: "post",
            url: "/updateEmail",
            data: postData,
          })
            .then((resp) => {
              this.handleCurrentChange();
              if (resp.status == 200) {
                var json = resp.data;
                if (json.status == "success") {
                  this.s1_cancel(ruleEmail);
                  this.$message({
                    type: "success",
                    message: this.$t("general.edit_completed"),
                  });
                } else if (json.status == "emailUpdateError") {
                  this.$message({
                    type: "error",
                    message: '更新されたメールアドレスが既に存在しています。',
                  });
                }
              } else {
                this.$message({
                  type: "warning",
                  message: 'サーバーエラー',
                });
                this.s1_cancel(ruleEmail);
              }
              console.log(response);
            })
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },
  },

  created() {
    this.axios
      .post("/pageUserHome")
      .then(response => {
        // this.ruleForm = response.data;
        this.tableForm = response.data;
        this.tableForm.plan == "a" ? this.tableForm.plan = "無料プラン" : this.tableForm.plan == "b" ? this.tableForm.plan = "スタンダードプラン" : this.tableForm.plan = "プロフェッショナルプラン";
        this.tableForm.locale == "ja" ? this.tableForm.locale = "日本語" : this.tableForm.locale = "英語";
        this.tableForm.password = "*********";
      })
      .catch(error => {

      });
  },


};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>

<style scoped>
.info-bg {
  background: #eeeeee;
}

.label-style1 {
  margin-left: 30px;
  margin-right: 50px;
  font-style: normal;
  font-weight: normal;
  font-size: xx-large;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  padding: 0px;
}
.label-style2 {
  margin-left: 30px;
  margin-right: 50px;
  margin-bottom: 0px;
  padding: 0px;
}
.p-style {
  text-align: left;
  color: red;
  font-size: 10px;
  margin-left: 30px;
  margin-top: 0px;
  padding-bottom: 30px;
}

.input-style1 {
  margin-left: 10px;
  margin-right: 0px;
  width: 250px;
}

.div-style {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/UserHome.vue